import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { themr } from '@friendsofreactjs/react-css-themr';

const SkeletonElement = ({ type = 'div', theme, isLoading, hidden, children, fullSize = false }) => {
    const className = classNames({
        [theme.skeleton]: isLoading,
        [theme[type]]: isLoading,
        [theme.fullSize]: fullSize,
        [theme.hidden]: isLoading && hidden,
    });

    return (
        <div className={ className }>
            { children }
        </div>
    );
};

SkeletonElement.propTypes = {
    type: PropTypes.string,
    children: PropTypes.node.isRequired,
    theme: PropTypes.shape({}),
    isLoading: PropTypes.bool,
    hidden: PropTypes.bool,
    fullSize: PropTypes.bool,
};

SkeletonElement.defaultProps = {
    type: 'div',
    hidden: false,
    isLoading: false,
};

export default themr('SkeletonElement')(SkeletonElement);
